import React, { useContext, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles from "./category.module.css";
import CategoryModal from "../../../Components/Modals/MenuCategoryModal/CategoryModal";
import MenuApi, { CategoryApi } from "../../../App/api/menu.apis";
import { RxCrossCircled } from "react-icons/rx";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import placeHolderImage from "../../../Assets/images/image-not-available.jpg";
import { useNavigate } from "react-router";
import AddCategory from "./AddCategory";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import ConfirmPopup from "../../../Components/ConfirmPopup";
import LoaderContext from "../../../Components/loader";
import { allRolePermission } from "../../../temp";
import OrderFilters from "../../../Components/Common/Filters/OrderFilters.jsx";
import PaginatorCom from "../../../Components/Paginator/PaginatorCom.jsx";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";

const CATEGORY_LIMIT = 10;

const Category = ({ meta }) => {
  const { handleLoading } = useContext(LoaderContext);
  const debounceTimeout = useRef(null);
  const [addCategory, setaddCategory] = useState(false);
  const [editCategoryData, setEditCategoryData] = useState(null);
  const [changeStore, setChangeStore] = useState(false);
  const [venderCategoryData, setVenderCategoryData] = useState([]);
  const [searchVenderCategory, setSearchVenderCategory] = useState("");
  const [isSubCategory] = useState(true);
  const [subCategory, setSubCategory] = useState(false);
  const [subCategoryData, setSubCategoryData] = useState(null);
  const [venderName, setVenderName] = useState(null);
  const [gridToggle, setGridToggle] = useState(false);
  const [venderId, setVenderId] = useState(null);
  const [categoryMeta, setCategoryMeta] = useState({
    page: 1,
    limit: CATEGORY_LIMIT,
    totalPages: 1,
    totalCount: 0,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: CATEGORY_LIMIT,
    sortOrder: "desc",
    filter: {},
  });
  const [isConfirm, setIsConfirm] = useState(false);
  const [accessCategory, setAccessCategory] = useState({
    read: false,
    add: false,
    update: false,
    delete: false,
  });
  const paginationFilterKey = JSON.stringify(pagination.filter);
  const venderFilterKey = JSON.stringify(venderId?.filter || {});

  const permission = allRolePermission;

  useEffect(() => {
    if (permission) {
      let accessRights = {
        read: false,
        add: false,
        update: false,
        delete: false,
      };

      permission.forEach((p) => {
        if (p?.component?.name === "menu_category") {
          accessRights = {
            read: p.permissions?.some((perm) => perm.permissionName === "Read"),
            add: p.permissions?.some(
              (perm) => perm.permissionName === "Create"
            ),
            update: p.permissions?.some(
              (perm) => perm.permissionName === "Update"
            ),
            delete: p.permissions?.some(
              (perm) => perm.permissionName === "Delete"
            ),
          };
        }
      });

      setAccessCategory(accessRights);
    }
  }, [permission]);

  // console.log("permissions>>>", permission);
  // console.log("accessCategory>>>", accessCategory);

  const fetchCategories = async () => {
    handleLoading(true);
    try {
      const mergedFilter = {
        ...(venderId?.filter || {}),
        ...(pagination.filter || {}),
      };
      const payload = {
        page: pagination.page,
        limit: pagination.limit,
        sortOrder: pagination.sortOrder,
        status: "Approved",
      };

      if (Object.keys(mergedFilter).length) {
        payload.filter = mergedFilter;
      }

      const res = await MenuApi.getVenderCategory(payload, searchVenderCategory);
      const data = res?.data?.data;

      setVenderCategoryData(data?.categories || []);
      setCategoryMeta({
        page: data?.page || 1,
        limit: data?.limit || CATEGORY_LIMIT,
        totalPages: data?.totalPages || 1,
        totalCount: data?.totalCount || 0,
      });
    } catch (error) {
      setVenderCategoryData([]);
      setCategoryMeta({
        page: 1,
        limit: CATEGORY_LIMIT,
        totalPages: 1,
        totalCount: 0,
      });
    } finally {
      handleLoading(false);
    }
  };

  const deleteCategory = async () => {
    handleLoading(true);
    try {
      await CategoryApi.deleteCategory(editCategoryData?._id);
    } catch (err) {
      // console.log(err);
      // showBoundary(err);
    } finally {
      handleLoading(false);
      setEditCategoryData(null);
      setIsConfirm(false);
      fetchCategories();
    }
  };

  useEffect(() => {
    const runFetch = async () => {
      await fetchCategories();
    };

    runFetch();
  }, [
    pagination.page,
    pagination.limit,
    pagination.sortOrder,
    paginationFilterKey,
    searchVenderCategory,
    venderFilterKey,
  ]);

  const getAllVenderCategory = async (vender_id, data) => {
    setVenderId(vender_id);
    setVenderName(data);
    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination);
      setSearchVenderCategory("");
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };

      if (data.filter) {
        const filterKey = Object.keys(data.filter)[0];
        const filterValue = Object.values(data.filter)[0];

        if (filterValue === undefined || filterValue === null || filterValue === "") {
          delete copyfilter[filterKey];
        } else if (copyfilter[filterKey]) {
          copyfilter[filterKey] = filterValue;
        } else {
          copyfilter = { ...data.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const handleCategoryClick = async (item) => {
    setSubCategoryData(item);
    setSubCategory(true);
  };

  const debouncedSearch = (query) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      setSearchVenderCategory(query);
      setPagination((prev) => ({
        ...prev,
        page: 1,
      }));
    }, 1000);
  };

  const handleFilter = (name, value) => {
    const data = {};

    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
      data.page = 1;
    }

    handlePagination(data);
  };

  const handleClearFilter = () => {
    handlePagination({
      clearPagination: {
        page: 1,
        limit: CATEGORY_LIMIT,
        sortOrder: "desc",
        filter: {},
      },
    });
  };

  const onPaginatorClick = (e) => {
    if (e) {
      handlePagination({
        limit: e.rows,
        page: +e.page + 1,
      });
    }
  };

  return (
    <>
      <CommonLayout />
      <div className={styles.container}>
        <div className={styles.top_content}>
          <div>
            <p className={styles.p1}>
              {venderName?.first_name || "All Stores"}
              <span className={styles.span1}>
                {venderName && `(${venderName?.address})`}
              </span>
            </p>
          </div>

          <div className="flex gap-2"></div>
        </div>
        <div className={styles.card}>
          <OrderFilters
            layoutView={true}
            gridToggle={gridToggle}
            SetGridToggle={setGridToggle}
            filters={categoryFilters}
            SearchBy={searchBy}
            WeekRange={false}
            MonthRange={true}
            canlenderFilter={canlenderFilter}
            handleFilter={handleFilter}
            handleClearFilter={handleClearFilter}
            handleSearch={debouncedSearch}
            actionButton={
              accessCategory.add
                ? {
                    button_name: "Add",
                    handleButton: () => setaddCategory(true),
                  }
                : null
            }
          />

          {gridToggle ? (
            <div className={styles.item__container}>
              {venderCategoryData?.length > 0 ? (
                venderCategoryData.map((item) => (
                  <CategoryGridCard
                    key={item._id}
                    item={item}
                    accessCategory={accessCategory}
                    handleCategoryClick={handleCategoryClick}
                    setSubCategory={setSubCategory}
                    setEditCategoryData={setEditCategoryData}
                    setIsConfirm={setIsConfirm}
                  />
                ))
              ) : (
                <div className={styles.emptyState}>No category found.</div>
              )}
            </div>
          ) : (
            <div className={styles.tableWrapper}>
              <DataTable
                value={venderCategoryData}
                dataKey="_id"
                emptyMessage="No category found."
              >
                <Column
                  header="Image"
                  body={(rowData) => (
                    <div
                      className={styles.cellClickable}
                      onClick={() => handleCategoryClick(rowData)}
                    >
                      {rowData?.image ? (
                        <LazyLoadImage
                          src={rowData.image}
                          alt={rowData?.name || "Category"}
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: ".5s" },
                          }}
                          className={styles.tableThumbnail}
                        />
                      ) : (
                        <img
                          src={placeHolderImage}
                          alt={rowData?.name || "Category"}
                          className={styles.tableThumbnail}
                        />
                      )}
                    </div>
                  )}
                />
                <Column
                  header="Date"
                  body={(rowData) => (
                    <div
                      className={styles.cellClickable}
                      onClick={() => handleCategoryClick(rowData)}
                    >
                      {moment(rowData?.createdAt).utc().format("DD MMM YYYY hh:mma")}
                    </div>
                  )}
                />
                <Column
                  header="Category"
                  body={(rowData) => (
                    <div
                      className={styles.cellClickable}
                      onClick={() => handleCategoryClick(rowData)}
                    >
                      {rowData?.name || ""}
                    </div>
                  )}
                />
                <Column
                  header="Subcategories"
                  body={(rowData) => (
                    <div
                      className={styles.cellClickable}
                      onClick={() => handleCategoryClick(rowData)}
                    >
                      {rowData?.subCategories?.length || 0}
                    </div>
                  )}
                />
                <Column
                  header="Status"
                  body={(rowData) => (
                    <div
                      className={styles.cellClickable}
                      onClick={() => handleCategoryClick(rowData)}
                    >
                      {rowData?.status || ""}
                    </div>
                  )}
                />
                <Column
                  header="Actions"
                  body={(rowData) => (
                    <div className={styles.tableActions}>
                      {accessCategory.update && (
                        <button
                          type="button"
                          className={styles.tableActionButton}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSubCategory(false);
                            setEditCategoryData(rowData);
                          }}
                          aria-label={`Edit ${rowData.name}`}
                        >
                          <FaRegEdit />
                        </button>
                      )}
                      {accessCategory.delete && (
                        <button
                          type="button"
                          className={styles.tableActionButton}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSubCategory(false);
                            setEditCategoryData(rowData);
                            setIsConfirm(true);
                          }}
                          aria-label={`Delete ${rowData.name}`}
                        >
                          <MdDeleteForever />
                        </button>
                      )}
                    </div>
                  )}
                />
              </DataTable>
            </div>
          )}

          <PaginatorCom
            paginatorData={{
              filters: null,
              first: 0,
              multiSortMeta: [],
              page: categoryMeta.page || 1,
              rows: categoryMeta.limit || CATEGORY_LIMIT,
              sortField: null,
              sortOrder: null,
              totalPages: categoryMeta.totalPages || 1,
              totalCount: categoryMeta.totalCount || 1,
            }}
            onPaginatorClick={onPaginatorClick}
          />
        </div>

        <SubCategory
          isSubCategory={isSubCategory}
          subCategoryData={subCategoryData}
          handleSubcategoryClick={(e) => console.log("e", e)}
          subCategory={subCategory}
          setSubCategory={setSubCategory}
        />
      </div>
      {changeStore && (
        <CategoryModal
          setChangeStore={setChangeStore}
          getAllVendorCategory={getAllVenderCategory}
        />
      )}
      <ConfirmPopup
        isOpen={Boolean(isConfirm)}
        onClose={() => setEditCategoryData(null)}
        onDelete={() => deleteCategory()}
        labels={{
          heading: "Are you sure?",
          paragraph: `Did you want to delete!`,
          button: "Yes",
        }}
      />
      <AddCategory
        currentItems={editCategoryData}
        open={Boolean(editCategoryData) || addCategory}
        handleClose={() => {
          setaddCategory(false);
          setEditCategoryData(null);
          fetchCategories();
        }}
      />
    </>
  );
};

export default Category;

const CategoryGridCard = ({
  item,
  accessCategory,
  handleCategoryClick,
  setSubCategory,
  setEditCategoryData,
  setIsConfirm,
}) => (
  <div
    onClick={() => handleCategoryClick(item)}
    className={`${styles.item} relative`}
    key={item._id}
  >
    <div className=" flex absolute top-0 right-0 z-[6] gap-2">
      {accessCategory.update && (
        <span
          className=" btn-border  w-10 h-10 rounded-full flex justify-center items-center text-[--color--11]"
          onClick={(e) => {
            e.stopPropagation();
            setSubCategory(false);
            setEditCategoryData(item);
          }}
        >
          <FaRegEdit className="text-[1rem]" />
        </span>
      )}
      {accessCategory.delete && (
        <span
          className=" btn-border  w-10 h-10 rounded-full flex justify-center items-center text-[--color--11]"
          onClick={(e) => {
            e.stopPropagation();
            setSubCategory(false);
            setEditCategoryData(item);
            setIsConfirm(true);
          }}
        >
          <MdDeleteForever className="text-[1rem]" />
        </span>
      )}
    </div>
    {item.image ? (
      <LazyLoadImage
        src={item?.image}
        effect="blur"
        wrapperProps={{
          style: { transitionDelay: ".5s" },
        }}
        className={styles.img}
      />
    ) : (
      <img src={placeHolderImage} alt="" className={styles.img} />
    )}
    <div className={styles.category_item}>
      <p className={styles.category_item_name}>{item.name}</p>
    </div>
  </div>
);

const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

const categoryFilters = [
  {
    filterType: "Category Type",
    inputName: "categoryType",
    options: [
      {
        name: "All",
        code: "",
      },
      {
        name: "Food",
        code: "Food",
      },
      {
        name: "Ecommerce",
        code: "Ecommerce",
      },
    ],
  },
];

const canlenderFilter = {
  filterType: "Category Date",
  inputName: "createdAt",
  maxDate: new Date(),
};

const SubCategory = ({
  isSubCategory,
  subCategoryData,
  handleSubcategoryClick,
  subCategory,
  setSubCategory,
}) => {
  const navigate = useNavigate();

  const handleSubcategoryItem = (item) => {
    navigate(`/app/menu/item/${item._id}-${item.name}`);
  };
  // console.log("subCategoryData", subCategoryData);
  return (
    <div
      className={`fixed top-0 right-0 z-50 h-full bg-white shadow-lg transition-all ${
        subCategory ? "w-96" : "w-0"
      } overflow-hidden`}
    >
      {/* Close Button */}
      <div className="absolute top-4 right-4">
        {subCategory && (
          <RxCrossCircled
            className="cursor-pointer text-gray-600 hover:text-red-500"
            size={"2.4rem"}
            onClick={() => setSubCategory(false)}
          />
        )}
      </div>

      {/* Header */}
      <div className="p-5">
        <h2 className="text-lg font-bold text-gray-700 mb-4">Sub Categories</h2>
        {subCategoryData?.image && (
          <img
            src={subCategoryData?.image}
            alt={subCategoryData?.name}
            className="w-full h-40 object-cover rounded-lg shadow-md"
          />
        )}
        <div className="mt-4">
          <p className="text-gray-800 text-lg font-semibold">
            {subCategoryData?.name}
          </p>
        </div>
      </div>

      {/* Subcategory List */}
      <div className="px-5 overflow-y-auto h-[calc(100%-200px)]">
        {subCategoryData?.subCategories?.length > 0 ? (
          subCategoryData?.subCategories.map((item) => (
            <div
              key={item._id}
              className={`flex items-center mt-2 gap-3 p-3 rounded-lg cursor-pointer transition ${
                item.is_visible
                  ? item.status === "Approved"
                    ? "hover:bg-green-100"
                    : "hover:bg-red-100"
                  : "bg-gray-100 cursor-not-allowed"
              }`}
              onClick={() => item.is_visible && handleSubcategoryItem(item)}
            >
              <div
                className={`w-4 h-4 rounded-full ${
                  item.is_visible
                    ? item.status === "Approved"
                      ? "bg-green-500"
                      : "bg-red-500"
                    : "bg-gray-400"
                }`}
              ></div>
              <p
                className={`flex-1 capitalize ${
                  item.is_visible
                    ? "text-gray-800"
                    : "text-gray-400 line-through"
                }`}
              >
                {item.name}
              </p>
              <span className="text-sm text-gray-500">{item.status}</span>
            </div>
          ))
        ) : (
          <p className="text-gray-500 mt-5">No subcategories available.</p>
        )}
      </div>
    </div>
  );
};
